import styled from "styled-components";
import LandingContentWrap from "_c/modules/landing/MainContentContainer";
import { StyledRoot as StyledAppLink } from "_c/native-app-link/styled";

export const Wrap = styled.div`
  overflow: hidden;
`;
export const ContentWrap = styled(LandingContentWrap)`
  margin-bottom: 0;
`;
export const Header = styled.header`
  max-width: 1920px;
  margin: 0 auto;
  min-height: 917px;
  background: url(/images/about-head.png) no-repeat center center;
  color: white;
  background-size: cover;
  position: relative;
  @media (max-width: 1200px) {
    min-height: 800px;
  }
  @media (max-width: 900px) {
    min-height: 600px;
  }
  @media (max-width: 700px) {
    background: url(/images/partners-head-sm2.jpg) no-repeat center center;
    background-size: cover;
    &::after {
      content: "";
      z-index: 1;
      pointer-events: none;
      position: absolute;
      height: 140px;
      width: 100%;
      bottom: 0;
      left: 0;
      background: ${({ theme }) => {
        const color =
          theme.__name__ === "dark" ? "18, 18, 18," : "255, 255, 255,";
        return `linear-gradient(
        0deg,
        rgba(${color} 1) 0%,
        rgba(${color} 0.75) 25%,
        rgba(${color} 0.5) 50%,
        rgba(${color} 0.25) 75%,
        rgba(${color} 0) 100%
      )`;
      }};
    }
  }
  @media (max-width: 550px) {
    min-height: 550px;
  }
`;
export const Hero = styled.div`
  color: inherit;
  text-align: center;
  position: relative;
  z-index: 2;
  max-width: 790px;
  margin-left: 12vw;
  h1 {
    padding-top: 60px;
    margin-top: 0;
    margin-bottom: 20px;
    font-family: ${({ theme }) => theme.font.accent};
    font-size: 76px;
    line-height: 1em;
    font-weight: 400;
  }
  p {
    white-space: pre-wrap;
    margin: 0 auto;
    margin-bottom: 80px;
    max-width: 490px;
    font-size: 15px;
    font-weight: 500;
    line-height: 20px;
    div {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
    }
  }
  ${StyledAppLink} {
    margin: 5px;
  }
  @media (max-width: 1200px) {
    margin-left: auto;
    margin-right: auto;
  }
  @media (max-width: 900px) {
    h1 {
      font-size: 42px;
      max-width: 600px;
      margin-left: auto;
      margin-right: auto;
    }
    p {
      margin-bottom: 50px;
    }
  }
  @media (max-width: 550px) {
    h1 {
      font-size: 32px;
    }
    p {
      margin-bottom: 30px;
    }
  }
  @media (max-width: 530px) {
    h1 {
      padding-top: 70px;
    }
    p {
      max-width: 90%;
    }
  }
`;
export const HeroButtons = styled.div`
  margin-bottom: 10px;
  button,
  a {
    display: inline-block;
    margin: 10px;
    padding: 15px 40px;
    vertical-align: middle;
  }
`;
export const SectHead = styled.header`
  text-align: center;
  color: var(--font-color-emp);
  h3 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 5px;
  }
  span {
    font-size: 18px;
    font-weight: 500;
  }
  @media (max-width: 500px) {
    h3 {
      font-size: 24px;
    }
    span {
      font-size: 16px;
    }
  }
`;
